import React, { createContext, useContext, useState } from 'react';

interface PaidSearchMetricContextType {
  selectedMetric: string | null;
  setSelectedMetric: (metric: string | null) => void;
}

const PaidSearchMetricContext = createContext<PaidSearchMetricContextType>({
  selectedMetric: null,
  setSelectedMetric: () => {}
});

export const PaidSearchMetricProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedMetric, setSelectedMetric] = useState<string | null>(null);

  return (
    <PaidSearchMetricContext.Provider value={{ selectedMetric, setSelectedMetric }}>
      {children}
    </PaidSearchMetricContext.Provider>
  );
};

export const usePaidSearchMetric = () => useContext(PaidSearchMetricContext);
